/**
 * WordPress dependencies
 */
import { SVG, Path } from '@wordpress/primitives';

const arrowDown = (
	<SVG xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
		<Path d="M16.2 13.2l-4 4V4h-1.5v13.3l-4.5-4.1-1 1.1 6.2 5.8 5.8-5.8-1-1.1z" />
	</SVG>
);

export default arrowDown;
